@if (successSend == false) {
  <div class="container">
    <div>
      @if (contactFormGroup) {
        <form [formGroup]="contactFormGroup" (ngSubmit)="onSendContact()">
          <div>
            <div>
              <h1>{{ 'contact.title' | t }}</h1>
            </div>
            <div>
              <label class="form-label">{{ 'contact.subject' | t }}</label>
              <select required  type="text" id="subject" name="subject" formControlName="subject" class="form-control" [class.is-invalid]="subject.invalid && (subject.dirty || subject.touched)">
                <option value="">{{ 'contact.chooseSubject' | t }}</option>
                @for (contactType of contactTypes; track contactType) {
                  <option required [label]="('contact.types.' + contactType) | t" [value]="contactType">{{ ('contact.types.' + contactType) | t }}</option>
                }
              </select>
              @if (subject.errors && subject.touched) {
                <div class="invalid-feedback">
                  @if (subject.errors?.['required']) {
                    <div>
                      {{ 'contact.required' | t }}
                    </div>
                  }
                </div>
              }
            </div>
            <div>
              <label class="form-label">{{ 'contact.pseudo' | t }}</label>
              <input  class="form-control" type="text" id="pseudo" name="pseudo" formControlName="pseudo" required minlength="1" maxlength="250" [class.is-invalid]="pseudo.invalid && (pseudo.dirty || pseudo.touched)">
              @if (pseudo.invalid && (pseudo.dirty || pseudo.touched)) {
                <div class="invalid-feedback">
                  @if (pseudo.errors?.['required']) {
                    <div>
                      {{ 'contact.required' | t }}
                    </div>
                  }
                  @if (pseudo.errors?.['minlength']) {
                    <div>
                      {{ 'contact.minLength' | t: { count: 1 } }}
                    </div>
                  }
                  @if (pseudo.errors?.['maxlength']) {
                    <div>
                      {{ 'contact.maxLength' | t: { count: 250 } }}
                    </div>
                  }
                </div>
              }
            </div>
            <div>
              <label class="form-label">{{ 'contact.email' | t }}</label>
              <input type="emailContact" id="emailContact" name="emailContact" formControlName="emailContact" required minlength="1" maxlength="250" class="form-control" [class.is-invalid]="emailContact.invalid && (emailContact.dirty || emailContact.touched)">
              @if (emailContact.invalid && (emailContact.dirty || emailContact.touched)) {
                <div class="invalid-feedback">
                  @if (emailContact.errors?.['required']) {
                    <div>
                      {{ 'contact.required' | t }}
                    </div>
                  }
                  @if (emailContact.errors?.['minlength']) {
                    <div>
                      {{ 'contact.minLength' | t: { count: 1 } }}
                    </div>
                  }
                  @if (emailContact.errors?.['maxlength']) {
                    <div>
                      {{ 'contact.maxLength' | t: { count: 250 } }}
                    </div>
                  }
                  @if (!emailContact.errors?.['required'] && !emailContact.errors?.['minlength'] && !emailContact.errors?.['maxlength'] && emailContact.errors?.['emailValidator']) {
                    <div>
                      {{ 'contact.invalidEmail' | t }}
                    </div>
                  }
                </div>
              }
            </div>
            <div>
              <label class="form-label">{{ 'contact.message' | t }}</label>
              <textarea  class="form-control" type="text" id="messageReceived" name="messageReceived" formControlName="messageReceived" required minlength="1" maxlength="2500" [class.is-invalid]="messageReceived.invalid && (messageReceived.dirty || messageReceived.touched)"></textarea>
              @if (messageReceived.invalid && (messageReceived.dirty || messageReceived.touched)) {
                <div class="invalid-feedback">
                  @if (messageReceived.errors?.['required']) {
                    <div>
                      {{ 'contact.required' | t }}
                    </div>
                  }
                  @if (messageReceived.errors?.['minlength']) {
                    <div>
                      {{ 'contact.minLength' | t: { count: 1 } }}
                    </div>
                  }
                  @if (messageReceived.errors?.['maxlength']) {
                    <div>
                      {{ 'contact.maxLength' | t: { count: 2500 } }}
                    </div>
                  }
                </div>
              }
            </div>
            <div>
              <button [disabled]="contactFormGroup.invalid" type="submit" class="btn btn-success">{{ 'contact.send' | t }}</button>
            </div>
          </div>
        </form>
        <br>
          <!-- {{contactFormGroup.value | json}} -->
        }
      </div>
    </div>
  }
  @if (successSend) {
    <div class="container">
      <div>
        <br>
          <br>
            <br>
              <h1 align="center">{{ 'contact.thanks' | t }}</h1>
              <p align="center">
                {{ 'contact.thanksText' | t }}
              </p>
              <br>
                <br>
                  <br>
                    <br>
                    </div>
                  </div>
                }
